import React from 'react';
import Fields from 'ui/form/FieldsForm';
import { getCountries, getCountryRegions } from 'utils/county-data';
import { isCustomerType } from '../consts';

export default function BusinessPart({ values, errors, onChange }) {
    const changeFactory = name => value => onChange(name, value);
    const changeCountry = value => {
        const firstKey = obj => obj && Object.keys(obj)[0];
        const regions = getCountryRegions(value);
        onChange({
            country: value,
            region: firstKey(regions) || '',
        });
    };

    const regions = getCountryRegions(values.country);
    const isNotCustomer = !isCustomerType(values.type);
    return (
        <React.Fragment>
            <Fields.Text
                label="Business name"
                value={values.business_name}
                error={errors.business_name}
                onChange={changeFactory('business_name')}
            />
            {isNotCustomer && (
                <React.Fragment>
                    <Fields.Text
                        label="Address line 1"
                        value={values.address1}
                        error={errors.address1}
                        onChange={changeFactory('address1')}
                    />
                    <Fields.Text
                        label="Address line 2"
                        value={values.address2}
                        error={errors.address2}
                        onChange={changeFactory('address2')}
                    />
                    <Fields.Text
                        label="City"
                        value={values.city}
                        error={errors.city}
                        onChange={changeFactory('city')}
                    />
                    <Fields.OneLine>
                        <Fields.Select
                            label="Country"
                            value={values.country}
                            error={errors.country}
                            onChange={changeCountry}
                            options={getCountries()}
                            native
                        />
                        {regions ? (
                            <Fields.Select
                                label="State"
                                value={values.region}
                                error={errors.region}
                                onChange={changeFactory('region')}
                                options={regions}
                                native
                            />
                        ) : (
                            <Fields.Text
                                label="Region"
                                value={values.region}
                                error={errors.region}
                                onChange={changeFactory('region')}
                            />
                        )}
                        <Fields.Text
                            label="ZIP / postal code"
                            value={values.postal_code}
                            error={errors.postal_code}
                            onChange={changeFactory('postal_code')}
                        />
                    </Fields.OneLine>
                </React.Fragment>
            )}
        </React.Fragment>
    );
}
